import { useSelect } from "@wordpress/data";
import { useState, useEffect } from "@wordpress/element";

export default function creative({ attributes, docSections, articlesNumber }) {
    const { col, titleText, titleTag, docs_layout, imageUrl, orderBy, menuOrder, sectionButton, sectionButtonText, btnURL, child_docs_order, isFeaturedImage } = attributes;

    const Title = () => {
        const tag = titleTag || 'h2';
        const Tag = titleTag;
        return <Tag className="title" data-animation="wow fadeInUp" data-wow-delay="0.2s">{titleText}</Tag>;
    };
    
    // Determine layout type based on attributes
    const layoutType = docs_layout === "grid" ? `ezd-grid ezd-column-${col}` : `ezd-masonry-wrap ezd-masonry-col-${col}`;

    const allDocItems = useSelect((select) => {
        const parentIds = docSections?.map((section) => section.id) || [];
        return parentIds.map((parentId) => ({
            parentId,
            items: select('core').getEntityRecords('postType', 'docs', {
                per_page: articlesNumber,
                orderby: orderBy,
                order: child_docs_order,
                parent: parentId,
                status: ['publish', 'private']
            }),
        }));
    }, [articlesNumber, orderBy, docSections, child_docs_order]); 

      // State for all featured media images
      const [images, setImages] = useState({});

      useEffect(() => {
          const fetchImages = async () => {
              if (!Array.isArray(docSections)) {
                  return;
              }    
              const imagePromises = docSections.map(async (section) => {
                  if (section.featured_media) {
                      try {
                          const media = await wp.apiFetch({ path: `/wp/v2/media/${section.featured_media}` });
                          return { id: section.id, imageUrl: media.source_url };
                      } catch (error) {
                          console.error("Error fetching media:", error);
                          return { id: section.id, imageUrl: null };
                      }
                  }
                  return { id: section.id, imageUrl: null };
              });    
              const results = await Promise.all(imagePromises);
              const imageMap = results.reduce((acc, { id, imageUrl }) => {
                  acc[id] = imageUrl;
                  return acc;
              }, {});
              setImages(imageMap);
          };
      
          const safeDocSections = docSections || [];
          fetchImages(safeDocSections);
      }, [docSections]);

    return (
        <>
            <section className="recommended_topic_area">
                <div className="recommended_topic_inner">
                   
                    <img src={imageUrl ?? ezdAssets.ezd_img_dir + '/widgets/docbg-shap.png'} className="doc_shap_one" alt="curve shape" />

                    <div className="doc_round one" data-parallax="{&quot;x&quot;: -80, &quot;y&quot;: -100, &quot;rotateY&quot;:0}"></div>
                    <div className="doc_round two" data-parallax="{&quot;x&quot;: -10, &quot;y&quot;: 70, &quot;rotateY&quot;:0}"></div>
                
                    <div className="doc_title text-center">
                        <h2 className="title" data-animation="wow fadeInUp" data-wow-delay="0.2s">
                            <Title />
                        </h2>
                    </div>

                    <div className="ezd-container">
                        <div className={`${layoutType}`}>

                            {docSections &&
                                docSections.map((section) => {
                                    const { id, title, featured_media } = section;
                                    const docItems = allDocItems.find((item) => item.parentId === id)?.items || [];
                                    const imageUrl = images[id];
                                    return (
                                        <>
                                            <div key={id} className="recommended_item box-item wow fadeInUp" data-wow-delay="0.2s">
                                                
                                                {isFeaturedImage && imageUrl && (
                                                    <img src={imageUrl} alt={title.rendered} />
                                                )}  
                                                                                             
                                                <a href=""> <h3 className="ct-heading-text">{title.rendered}</h3> </a>
                                                <ul className="ezd-list-unstyled">
                                                    {docItems && docItems.map((item) => (
                                                        <li key={item.id}>
                                                            <a className="ct-content-text" href=""> {item.title.rendered} </a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </>
                                    );
                            })}
                        </div>
                    </div>

                    {sectionButton && (
                        <div className="text-center wow fadeInUp" data-wow-delay="0.2s">
                            <a href={`${btnURL}`} className="question_text"> 
                                {sectionButtonText} <i className="arrow_right"></i> 
                            </a>
                        </div>
                    )}

                </div>
            </section>
        </>
    );    
}